import { IConfig } from '../types/config';

// eslint-disable-next-line
export default async function (): Promise<IConfig> {
  const resp = await fetch(window.location.origin + '/config.json', {
    cache: 'no-store',
  });
  return await resp.json();
}
